import React from 'react'
import strings from 'utils/strings'
import PropTypes from 'prop-types'
import { RadioButtonGroup } from 'components/patterns'
import { getSelectedId } from 'selectors/navigator'
import { useSelector } from 'hooks/redux'
import {
  ADD_REMOVE_FEATURES,
  ADD_REMOVE_FEATURE_COLLECTIONS,
  APPLY_FAST_FEATURES,
} from 'utils/constants/vehicle-constants'
import { StyledHovarableInfoIcon } from './FeatureCollections/Search.style'
import {
  useFeatureToggleStatus,
  useHandleTabChange,
} from './utils/feature-toggle-logic'

const FeatureCollectionToggle = ({
  serialNumber,
  hideFeatureCollectionToggle,
  hideFastFeatureToggle,
}) => {
  const currentValue = useSelector(getSelectedId)

  // Get the tab change handler with all logic encapsulated
  const handleTabChange = useHandleTabChange(serialNumber, currentValue)

  // Handle onChange event from RadioButtonGroup
  const handleOnChange = ({ target: { value } }) => {
    handleTabChange(value)
  }

  // Determine the status of the FAST Features toggle using the custom hook
  const shouldHideFastFeatures = useFeatureToggleStatus(serialNumber)

  // If Smart Switches are detected, hide the entire toggle group
  if (hideFeatureCollectionToggle && shouldHideFastFeatures) return null

  const toggleButtons = [
    {
      key: ADD_REMOVE_FEATURES,
      value: ADD_REMOVE_FEATURES,
      text: strings.add_individual_features,
    },
  ]

  // Only display 'Feature Collections' if not hidden by prop
  if (!hideFeatureCollectionToggle) {
    toggleButtons.push({
      key: ADD_REMOVE_FEATURE_COLLECTIONS,
      value: ADD_REMOVE_FEATURE_COLLECTIONS,
      text: strings.use_feature_collection,
    })
  }

  // Only display 'FAST Features' if not hidden by prop
  if (!hideFastFeatureToggle) {
    toggleButtons.push({
      key: APPLY_FAST_FEATURES,
      value: APPLY_FAST_FEATURES,
      text: strings.use_fast_features,
    })
  }

  // Simplified rendering variables
  const shouldShowRadioGroup = toggleButtons.length > 1
  const shouldShowInfoIcon =
    shouldShowRadioGroup && currentValue === ADD_REMOVE_FEATURE_COLLECTIONS

  // Render nothing if there are no options and no info icon to show
  if (!shouldShowRadioGroup && !shouldShowInfoIcon) return null

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {shouldShowRadioGroup && (
        <RadioButtonGroup
          onChange={handleOnChange}
          currentValue={currentValue}
          buttons={toggleButtons}
        />
      )}
      {shouldShowInfoIcon && (
        <StyledHovarableInfoIcon
          tooltipPosition="right"
          centerRight
          tooltip={
            strings.collections_can_be_used_to_quickly_apply_multiple_featues
          }
          overlayClassName="autoWidth"
        />
      )}
    </div>
  )
}

FeatureCollectionToggle.propTypes = {
  serialNumber: PropTypes.string,
  hideFeatureCollectionToggle: PropTypes.bool,
  hideFastFeatureToggle: PropTypes.bool,
}

export default FeatureCollectionToggle
